export default __webpack_public_path__ + "static/media/11.2f722017.mp3";